import React from 'react';
type SectionHeadingProps = {
  id: string;
  title: React.ReactNode;
  intro?: string;
  align?: 'center' | 'left';
};
export function SectionHeading({
  id,
  title,
  intro,
  align = 'center'
}: SectionHeadingProps) {
  const centered = align === 'center';
  return <div className={centered ? 'mx-auto max-w-2xl text-center' : 'max-w-xl'} data-id="element-246" data-mp="3f36mp84b351v">
      <h2 id={id} className="text-balance font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-247" data-mp="3k0oxl41vvuci">
        {title}
      </h2>
      {intro && <p className="mt-4 text-pretty text-lg leading-relaxed text-ink-soft" data-id="element-248" data-mp="gj6v7c4vrfjh">{intro}</p>}
    </div>;
}